import { combineReducers } from 'redux';
import * as types from '../constants';

const ids = (state = [], action) => {
  switch (action.type) {
    case types.FETCH_SHOPS_SUCCESS:
      return action.payload;
    case types.FETCH_ADMIN_SHOPS_BY_ID: {
      const shopIds = action.payload.map(shop => shop.id);
      return [
        ...(state.filter(shop => !shopIds.includes(shop.id))),
        ...action.payload,
      ];
    }
    case types.FETCH_SHOPS_DISABLED_SUCCESS:
      return [
        ...state,
        ...action.payload,
      ];
    default:
      return state;
  }
};

export default combineReducers({
  ids,
});

export const getIds = state => state.ids;
